<template>
  <CockpitDialog class="environmentDataDialog" title="环境监测数据" @close="close">
    <p class="w-full text-center text-18px text-[#fff]">厂区东门扬尘监测</p>
    <el-date-picker class="mt-20px" v-model="data" type="date" size="small" placeholder="选择日期">
    </el-date-picker>
    <TableButtonGroup
      :list="typteList"
      :value="typtValue"
      class="mt-10px"
      @btn-click="btnClick"
    ></TableButtonGroup>
    <!-- <el-radio-group class="mt-10px block" v-model="typtValue" size="mini">
      <el-radio-button
        :label="item.name"
        v-for="(item, index) in typteList"
        :key="index"
      ></el-radio-button>
    </el-radio-group> -->
    <div class="chartBox w-full">
      <v-chart
        :options="environmentOption"
        autoresize
        class="w-100 h-100 environmentOption"
        ref="environmentOption"
      ></v-chart>
    </div>
  </CockpitDialog>
</template>

<script>
const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
const TableButtonGroup = () => {
  return import('@/components/cockpit/TableButtonGroup')
}
export default {
  name: 'environmentDataDialog',
  components: {
    CockpitDialog,
    TableButtonGroup,
  },
  data() {
    return {
      cameraList: [{ name: 'shexiangt1' }, { name: 'shexiangt2' }],
      total: 0,
      pageSize: 5,
      currentPage: 1,
      data: '',
      typteList: [
        '温度',
        '气压',
        '湿度',
        '风速',
        '风力',
        'PM2.5',
        'PM10',
        '噪音',
        // { name: '温度', value: 1 },
        // { name: '气压', value: 2 },
        // { name: '湿度', value: 3 },
        // { name: '风速', value: 4 },
        // { name: '风力', value: 5 },
        // { name: 'PM2.5', value: 6 },
        // { name: 'PM10', value: 7 },
        // { name: '噪音', value: 8 },
      ],
      typtValue: '温度',
      environmentOption: {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 20,
          left: 40,
          bottom: 20,
          right: 20,
        },
        xAxis: [
          {
            type: 'category',
            data: ['09:00', '10:00', '11:00', '12:00', '13:00'],
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.6)',
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: 'rgba(255,255,255,0.6)',
                fontSize: 12,
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            max: 2000,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.6)',
              },
            },
            axisLabel: {
              color: 'rgba(255,255,255,0.6)',
              fontSize: 12,
              formatter: '{value}',
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.1)',
              },
            },
          },
        ],
        series: [
          {
            name: '气压',
            type: 'line',
            data: [1, 34, 56, 77, 100],
            itemStyle: {
              color: 'rgba(0,255,207,1)',
            },
            areaStyle: {
              color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(0,255,207,1)',
                },
                {
                  offset: 1,
                  color: 'rgba(0,255,207,0)',
                },
              ]),
            },
          },
        ],
      },
    }
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
    btnClick(val) {
      this.typtValue = val
    },
  },
}
</script>
<style lang="scss" scoped>
.environmentDataDialog {
  left: -1000px;
  top: -24px;
}
.chartBox {
  height: calc(100% - 150px);
  .environmentOption {
    width: 100%;
    height: 100%;
  }
}
</style>
